'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledText = require('../styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _icons = require('../../icons');

var _proptypes = require('../util/proptypes');

var _util = require('../util');

require('./checkbox.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-check-box-';

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this.onChangeFunc = function (event) {
      event && event.stopPropagation(); //prevent checkbox parent from being clicked, i.e. table row

      var _this$props = _this.props,
          disabled = _this$props.disabled,
          _this$props$input = _this$props.input,
          input = _this$props$input === undefined ? {} : _this$props$input,
          onChange = _this$props.onChange;
      var isChecked = _this.state.isChecked;
      var handleOnChange = onChange || input.onChange;
      if (disabled) return;
      if (handleOnChange) handleOnChange(!_this.handleIsChecked(), event);

      _this.setState({
        isChecked: !isChecked
      });
    };

    _this.handleIsChecked = function () {
      var input = _this.props.input;
      var isChecked = _this.state.isChecked;
      if (input && input.value) return !!input.value;
      return isChecked;
    };

    _this.getCheckmarkIcon = function () {
      var isChecked = _this.state.isChecked;

      if (!isChecked) {
        return null;
      }

      var customCheckmark = _this.props.customCheckmark;

      if (!!customCheckmark) {
        return customCheckmark;
      }

      return _react2.default.createElement(_icons.CheckmarkThickIcon, {
        width: 12,
        height: 12,
        color: '#FFFFFF'
      });
    };

    _this.state = {
      isChecked: props.checked
    };
    _this.checkBoxWrapper = _react2.default.createRef();
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          shouldFocus = _props.shouldFocus,
          disabled = _props.disabled;
      if (this.checkBoxWrapper.current && shouldFocus && !disabled) this.checkBoxWrapper.current.focus();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var checked = this.props.checked;
      var isChecked = this.state.isChecked;

      if (prevProps.checked !== checked && isChecked !== checked) {
        this.setState({
          isChecked: checked
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this,
          _classNames2,
          _classNames3;

      var _props2 = this.props,
          autoFocus = _props2.autoFocus,
          checkboxStyle = _props2.checkboxStyle,
          className = _props2.className,
          containerStyle = _props2.containerStyle,
          disabled = _props2.disabled,
          error = _props2.error,
          label = _props2.label,
          labelBefore = _props2.labelBefore,
          labelStyle = _props2.labelStyle,
          _props2$tabIndex = _props2.tabIndex,
          tabIndex = _props2$tabIndex === undefined ? 0 : _props2$tabIndex,
          textClassName = _props2.textClassName,
          _props2$testid = _props2.testid,
          testid = _props2$testid === undefined ? '' : _props2$testid;
      var isChecked = this.state.isChecked;
      return _react2.default.createElement('div', {
        'data-testid': testid,
        onClick: this.onChangeFunc,
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'hover', true), _defineProperty(_classNames, labelBefore ? STYLE_BASE + 'container-label-before' : STYLE_BASE + 'container', true), _defineProperty(_classNames, className, !!className), _classNames)),
        style: containerStyle,
        onKeyDown: function onKeyDown(e) {
          return (0, _util.basicKeyToggle)(e, _this2.onChangeFunc);
        }
      }, _react2.default.createElement('div', {
        autoFocus: autoFocus,
        ref: this.checkBoxWrapper,
        className: (0, _classnames2.default)((_classNames2 = {
          'zk-check-box': true
        }, _defineProperty(_classNames2, STYLE_BASE + 'checked-style', isChecked), _defineProperty(_classNames2, STYLE_BASE + 'disabled-check-box', disabled), _defineProperty(_classNames2, STYLE_BASE + 'error-border', !!error), _classNames2)),
        style: checkboxStyle,
        tabIndex: disabled ? -1 : tabIndex,
        'data-testid': label + '_CHECK_MARK_ICON_WRAPPER'
      }, this.getCheckmarkIcon()), _react2.default.createElement(_styledText2.default, {
        numberOfLines: 1,
        className: (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, STYLE_BASE + 'label-style', true), _defineProperty(_classNames3, labelBefore ? STYLE_BASE + 'label-before' : STYLE_BASE + 'label-right', true), _defineProperty(_classNames3, STYLE_BASE + 'disabled-text-color', disabled), _defineProperty(_classNames3, textClassName, !!textClassName), _classNames3)),
        style: labelStyle
      }, label));
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.displayName = 'CheckBox';
Checkbox.propTypes = {
  checkboxStyle: _proptypes.STYLE_PROP,
  checked: _propTypes2.default.bool,
  checkedImage: _propTypes2.default.string,
  containerStyle: _proptypes.STYLE_PROP,
  customCheckmark: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node, _propTypes2.default.element]),
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.element]),
  labelBefore: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  testid: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  uncheckedImage: _propTypes2.default.string
};
Checkbox.defaultProps = {
  checked: false
};
exports.default = Checkbox;